<h2 mat-dialog-title>
  {{ 'actions.employee_profile' | translate }}
  <span class="icon-close icon-Cross" mat-dialog-close></span>
</h2>
<ng-container *ngIf="permissionService.abilities$ | async as ability">
  <mat-dialog-content>
    <ng-container *ngIf="data$ | async as data">
        <div class="employee">
          <div class="employee__info">
            <img [src]="data.pictureLink ? data.pictureLink : './assets/images/default-user-image.svg'" alt="" />

            <div class="employee__info-data">
              <div *ngIf="isFieldNotEmpty('firstName')" class="employee__info-data__name">{{ data | fullName }}</div>
              <div *ngIf="isFieldNotEmpty('birthDate')" class="employee__info-data__birth">
                <div class="label">{{ 'form.fields.birth_date' | translate }}</div>
                <div class="value">
                  {{ ability.role.can(ACTION.EDIT, SUBJECT.EMPLOYEE) ? (data.birthDate | date: 'dd.MM.yyyy') : (data.birthDate | date: 'dd.MM') }}
                </div>
              </div>
            </div>
          </div>

          <div class="employee__grid">
            <div class="divider">
              <div class="col-title">{{ 'form.subtitles.main_info' | translate }}</div>
            </div>

            <ng-container *ngIf="isFieldNotEmpty('titles')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.title' | translate }}</div>
              <div class="col-value">
                <app-status-label *ngFor="let title of data.titles" [label]="title"></app-status-label>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('status')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.employment_status' | translate }}</div>
              <div class="col-value">
                <app-status-label [label]="data.status"></app-status-label>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('roles')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.role' | translate }}</div>
              <div class="col-value column-flow">
                <span *ngFor="let role of data.roles">
                  {{ 'employee.role.' + role + '.name' | translate }}
                </span>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('startDate')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.hire_date' | translate }}</div>
              <div class="col-value">
                {{ data.startDate | date: 'dd.MM.yyyy' }} <span class="hint">{{ data.startDate! | durationSince: data.leaveDate }}</span>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('availability')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.availability' | translate }}</div>
              <div class="col-value">
                <app-status-label [label]="data.availability"></app-status-label>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('leaveDate')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.leave_date' | translate }}</div>
              <div class="col-value">
                {{ data.leaveDate | date: 'dd.MM.yyyy' }}
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('leaveReason')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.leave_reason' | translate }}</div>
              <div class="col-value">
                {{ data.leaveReason }}
              </div>
            </ng-container>

            <!-- <ng-container *ngIf="isFieldNotEmpty('fop') && data.fop == true">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.is_fop' | translate }}</div>
              <div class="col-value">{{ 'form.fields.yes' | translate }}</div>
            </ng-container> -->

            <div class="divider">
              <div class="col-title">{{ 'form.subtitles.managers' | translate }}</div>
            </div>

            <ng-container *ngIf="isFieldNotEmpty('primaryManager')">
              <div class="col-empty"></div>
              <div class="col-label height-32">{{ 'form.fields.primary_manager' | translate }}</div>
              <div class="col-value">
                <app-employee-avatar
                  *ngIf="employeeService.getEmployeeObjectById(data.primaryManager) as user"
                  [employee]="user"
                  [size]="'xl'"></app-employee-avatar>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('secondaryManagers')">
              <div class="col-empty"></div>
              <div class="col-label height-32">{{ 'form.fields.secondary_managers' | translate }}</div>
              <div class="col-value column-flow">
                <ng-container *ngFor="let user of employeeService.getEmployeeObjectByIds(data.secondaryManagers!)">
                  <app-employee-avatar *ngIf="user" [employee]="user" [size]="'xl'"></app-employee-avatar
                ></ng-container>
              </div>
            </ng-container>

            <div class="divider">
              <div class="col-title">{{ 'form.subtitles.contacts' | translate }}</div>
            </div>

            <ng-container *ngIf="isFieldNotEmpty('email')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.work_email' | translate }}</div>
              <div class="col-value nowrap">
                {{ data.email }}
                <span class="icon-Copy icon-hover" [matTooltip]="'actions.copy' | translate" (click)="onCopyText(data.email)"></span>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('personalEmail')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.personal_email' | translate }}</div>
              <div class="col-value nowrap">
                {{ data.personalEmail }}
                <span class="icon-Copy icon-hover" [matTooltip]="'actions.copy' | translate" (click)="onCopyText(data.personalEmail!)"></span>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('phone')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.phone' | translate }}</div>
              <div class="col-value">
                {{ data.phone }}
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('location')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.country' | translate }}</div>
              <div class="col-value">
                {{ locationName }}
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('localTime')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.time_zone' | translate }}</div>
              <div class="col-value">{{ data.localTime | date: 'dd.MM.yyyy HH:mm' }} {{ timezoneOffset(data.localTime!) }}</div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('contactAddress')">
              <div class="col-empty"></div>
              <div class="col-label">{{ 'form.fields.contact_address' | translate }}</div>
              <div class="col-value">{{ data.contactAddress }}</div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('linkedin') || isFieldNotEmpty('instagram') || isFieldNotEmpty('facebook') || isFieldNotEmpty('telegram')">
              <div class="divider">
                <div class="col-title">{{ 'form.subtitles.social_network' | translate }}</div>
              </div>

              <div class="col-empty"></div>
              <div class="col-value combined social-icons">
                <a *ngIf="isFieldNotEmpty('linkedin')" [href]="data.linkedin" target="_blank">
                  <img src="./assets/images/social/linkedin.svg" alt="Linkedin" />
                </a>
                <a *ngIf="isFieldNotEmpty('instagram')" [href]="data.instagram" target="_blank">
                  <img src="./assets/images/social/instagram.svg" alt="Instagram" />
                </a>
                <a *ngIf="isFieldNotEmpty('facebook')" [href]="data.facebook" target="_blank"><img src="./assets/images/social/facebook.svg" alt="Facebook" /></a>
                <a *ngIf="isFieldNotEmpty('telegram')" [href]="'https://t.me/' + data.telegram!.replace('@', '')" target="_blank">
                  <img src="./assets/images/social/telegram.svg" alt="Telegram" />
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('projects')">
              <div class="divider">
                <div class="col-title">{{ 'form.subtitles.projects' | translate }}</div>
              </div>

              <div class="col-empty"></div>
              <div class="col-value combined column-flow gap-16">
                <span class="row-span" *ngFor="let item of data.projects">
                  <app-status-label [label]="item.project"></app-status-label>
                  <span class="hint"> {{ item.startDate | date: 'dd.MM.yyyy' }} - {{ (item.endDate | date: 'dd.MM.yyyy') || ('messages.now' | translate) }} </span>
                </span>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('kids')">
              <div class="divider">
                <div class="col-title">{{ 'form.subtitles.children' | translate }}</div>
              </div>

              <div class="col-empty"></div>
              <div class="col-value combined column-flow">
                <span class="row-span" *ngFor="let kid of data.kids">
                  <img [src]="'./assets/images/' + kid.gender.toLowerCase() + '.png'" alt="" />
                  <div class="hint-column">
                    {{ kid.name }} <span class="hint">{{ kid.birthDate | date: 'dd.MM.yyyy' }} </span>
                  </div>
                </span>
              </div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('needToKnow')">
              <div class="divider">
                <div class="col-title">{{ 'form.subtitles.need_to_know' | translate }}</div>
              </div>

              <div class="col-empty"></div>
              <div class="col-value combined">{{ data.needToKnow }}</div>
            </ng-container>

            <ng-container *ngIf="isFieldNotEmpty('hrNote')">
              <div class="divider">
                <div class="col-title">{{ 'form.subtitles.hr_notes' | translate }}</div>
              </div>

              <div class="col-empty"></div>
              <div class="col-value combined">{{ data.hrNote }}</div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <app-loader></app-loader>
  </mat-dialog-content>
  <mat-dialog-actions [align]="'end'" *ngIf="ability.role.can(ACTION.EDIT, SUBJECT.EMPLOYEE) || isOwnProfile">
    <button
      class="btn-main btn-primary btn-xl"
      (click)="onEdit()"
      [disabled]="!ability.subscription.can(ACTION.EDIT, SUBJECT.EMPLOYEE)">
      {{ 'actions.edit' | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>
